"use strict";
const assert = require('assert').strict;
const parseVariable = require('./parseVariable');
const { STRING } = require('../../definitions/operandValueTypes');
module.exports = (itemString) => {
    assert(typeof itemString === 'string');
    const list = itemString
        .split(',')
        .map((item) => item.trim())
        .map((value) => parseVariable({ valueType: STRING, value }));
    return list;
};
//# sourceMappingURL=csvToList.js.map